/** @jsx h */
/** @jsxFrag Fragment */
import { Fragment, h } from "preact";
import { DatUIBaseProps } from "./dat.tsx";
import { cx } from "@utils/utils";

export interface DatPresetsProps extends DatUIBaseProps {}
export function DatPresets(props: DatPresetsProps) {
  const labelWidth = "40%";

  const labelText = props.label || "DefaultLabel";

  const options = [{ a: {} }];

  return (
    <li class={cx("cr", "presets", props.class)} style={props.style}>
      <label>
        <span class="label-text" style={{ width: labelWidth }}>
          {labelText}
        </span>
        <select style={{ width: `calc(100% - ${labelWidth})` }}>
          {options.map((preset) => {
            return Object.keys(preset).map((key) => {
              return (
                <option key={key} value={key}>
                  {key}
                </option>
              );
            });
          })}
        </select>
      </label>
    </li>
  );
}

export interface DatSelectProps extends DatUIBaseProps {
  value: string;
  options: string[];
  optionLabels: string[];
}
export function DatSelect(props: DatSelectProps) {
  const labelWidth = "40%";
  const labelText = props.label || "DefaultLabel";

  return (
    <li class={cx("cr", "select", props.class)} style={props.style}>
      <label>
        <span class="label-text" style={{ width: labelWidth }}>
          {labelText}
        </span>
        <select
          value={props.value}
          onChange={(e) => {
            //@ts-ignore:
            props.onChange(e.target.value);
          }}
          style={{ width: `calc(100% - ${labelWidth})` }}
        >
          {props.options.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <option key={index} value={item}>
              {props.optionLabels ? props.optionLabels[index] : item}
            </option>
          ))}
        </select>
      </label>
    </li>
  );
}
